import React, { useEffect, useState } from "react";
import { domain, getPeriods } from "../../assets/js/api";
import { getCurrentLanguage, translate } from "../../assets/js/functions";
import tituloPortadaEs from "../../assets/img/titular-expo.svg";
import tituloPortadaMobileEs from "../../assets/img/titular-expo-mobile.svg";
import tituloPortadaEu from "../../assets/img/titular-expo-euskera.svg";
import tituloPortadaMobileEu from "../../assets/img/titular-expo-mobile-euskera.svg";
import LayoutHome from "../../components/Layout/Home";
import HomeFooter from "../../components/Partials/HomeFooter";
import Menu from "../../components/Partials/Menu";
import { Link } from "react-router-dom";
import Langs from "../../components/Partials/Langs";
import { getImageSize } from "react-image-size";

export default function Home({ lang }) {
  const [periods, setPeriods] = useState(null);
  const [titol, setTitol] = useState(null);
  const [titolMobile, setTitolMobile] = useState(null);
  const [imageSizes, setImageSizes] = useState(null);

  useEffect(() => {
    const lang = getCurrentLanguage();
    if (lang == "es") {
      setTitol(tituloPortadaEs);
      setTitolMobile(tituloPortadaMobileEs);
    } else if (lang == "eu") {
      setTitol(tituloPortadaEu);
      setTitolMobile(tituloPortadaMobileEu);
    }
  }, [lang]);

  useEffect(() => {
    const fetchImageSizes = async () => {
      const periodsData = await getPeriods();
      setPeriods(periodsData);

      const sizePromises = periodsData.map((period) =>
        getImageSize(domain + period.image.image)
      );

      const sizes = await Promise.all(sizePromises);

      setImageSizes(sizes);
    };

    fetchImageSizes();
  }, []);

  return (
    <LayoutHome pageMeta={{}}>
      <header>
        <a href="#main-nav" className="skip-link">
          Menú principal
        </a>
        <a href="#main" className="skip-link">
          Contenido principal
        </a>
        <div className="is-flex is-align-items-center gap-7 pt-5 px-6">
          {periods ? <Menu periods={periods} /> : ""}
          <Langs></Langs>
        </div>

        <h1
          aria-label={translate('Símbolos de un tiempo')}
          className="has-text-centered px-6"
        >
          <img
            loading="lazy"
            src={titolMobile}
            alt={translate('Símbolos de un tiempo')}
            width="169"
            height="60"
            className="is-hidden-tablet"
          />
          <img
            loading="lazy"
            src={titol}
            alt=""
            width="850"
            height="80"
            className="is-hidden-mobile mt-5"
          />
        </h1>
      </header>
      <main className="main-content py-5" id="main">
        <div className="wrapper">
          <nav className="home-nav link-dn">
            <ol className="is-flex is-relative">
              <li className="is-relative">
                <h2 className="has-text-weight-bold h-100">
                  {periods && (
                    <React.Fragment>
                      <Link
                        className="is-flex is-flex-direction-column gap-4 h-100 "
                        to={"/exposition#" + periods[0].term_id}
                      >
                        <span className="is-block is-family-secondary is-relative">
                          {periods[0].start}
                        </span>

                        <span className="is-block">
                          <span className="is-hidden-widescreen is-size-3">
                            {periods[0].title}
                          </span>

                          <span className="is-block m-0 bg-title-primary has-text-centered is-size-2 has-text-weight-bold is-hidden-desktop-only is-hidden-touch">
                            {periods[0].title}
                          </span>
                        </span>
                        {imageSizes && (
                          <img
                            loading="lazy"
                            src={domain + periods[0].image.image}
                            width={imageSizes[0].width}
                            height={imageSizes[0].height}
                            alt=""
                          />
                        )}
                      </Link>
                    </React.Fragment>
                  )}
                </h2>
              </li>
              <li className="is-relative">
                <h2 className="has-text-weight-bold h-100">
                  {periods && (
                    <React.Fragment>
                      <Link
                        className="is-flex is-flex-direction-column gap-4 h-100"
                        to={"/exposition#" + periods[1].term_id}
                      >
                        <span className="is-block is-family-secondary is-relative">
                          {periods[1].start}
                        </span>

                        <span className="is-block">
                          <span className="is-hidden-widescreen is-size-3">
                            {periods[1].title}
                          </span>

                          <span className="is-block m-0 bg-title-primary has-text-centered is-size-2 has-text-weight-bold is-hidden-desktop-only is-hidden-touch">
                            {periods[1].title}
                          </span>
                        </span>
                        {imageSizes && (
                          <img
                            loading="lazy"
                            src={domain + periods[1].image.image}
                            width={imageSizes[1].width}
                            height={imageSizes[1].height}
                            alt=""
                          />
                        )}
                      </Link>
                    </React.Fragment>
                  )}
                </h2>
              </li>
              <li className="is-relative">
                <h2 className="has-text-weight-bold h-100">
                  {periods && (
                    <React.Fragment>
                      <Link
                        className="is-flex is-flex-direction-column gap-4 h-100"
                        to={"/exposition#" + periods[1].term_id}
                      >
                        <span className="is-block is-family-secondary is-relative">
                          {periods[2].start}
                        </span>

                        <span className="is-block">
                          <span className="is-hidden-widescreen is-size-3">
                            {periods[2].title}
                          </span>

                          <span className="is-block m-0 bg-title-primary has-text-centered is-size-2 has-text-weight-bold is-hidden-desktop-only is-hidden-touch">
                            {periods[2].title}
                          </span>
                        </span>
                        {imageSizes && (
                          <img
                            loading="lazy"
                            src={domain + periods[2].image.image}
                            width={imageSizes[2].width}
                            height={imageSizes[2].height}
                            alt=""
                          />
                        )}
                        <span className="is-block is-family-secondary is-relative">
                          {periods[2].end}
                        </span>
                      </Link>
                    </React.Fragment>
                  )}
                </h2>
              </li>
            </ol>
          </nav>
        </div>
      </main>
      <HomeFooter></HomeFooter>
    </LayoutHome>
  );
}
